module.exports = __webpack_public_path__ + "img/commerciale_pressed.3d37b18c.png";